/**
 * AddPatient 表单校验工具 - 纯函数，无平台依赖
 */

const NAME_REG = /^([\u4e00-\u9fa5][\u4e00-\u9fa5· ]+|[a-zA-Z· ]+){1,10}$/;
const NUMBER_WORD_REG = /^[0-9a-zA-Z]+$/;

export function isUsername(name: string): boolean {
  if (!name || name.length === 0) return true;
  return NAME_REG.test(name);
}

export function isNumberAndWord(value: string): boolean {
  if (!value || value.length === 0) return true;
  return NUMBER_WORD_REG.test(value);
}

export interface IdCardParseResult {
  birthday: string;
  sex: 'M' | 'F';
}

export function isIdCard(card: string): IdCardParseResult | false {
  if (!card) return false;
  let num = card;
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/i.test(num)) return false;

  let birthday: string;
  let sex: 'M' | 'F';
  const len = num.length;

  if (len === 15) {
    birthday = `19${card.substring(6, 8)}-${card.substring(8, 10)}-${card.substring(10, 12)}`;
    sex = parseInt(card.substr(14, 1), 10) % 2 === 1 ? 'M' : 'F';
    const re = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    const arrSplit = num.match(re);
    if (!arrSplit) return false;
    const dtmBirth = new Date(`19${arrSplit[2]}/${arrSplit[3]}/${arrSplit[4]}`);
    const bGoodDay =
      dtmBirth.getFullYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) return false;

    const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let nTemp = 0;
    num = `${num.substr(0, 6)}19${num.substr(6, num.length - 6)}`;
    for (let i = 0; i < 17; i++) {
      nTemp += parseInt(num.substr(i, 1), 10) * arrInt[i];
    }
    num += arrCh[nTemp % 11];
  } else {
    birthday = `${card.substring(6, 10)}-${card.substring(10, 12)}-${card.substring(12, 14)}`;
    sex = parseInt(card.substr(16, 1), 10) % 2 === 1 ? 'M' : 'F';
    const re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/i;
    const arrSplit = num.match(re);
    if (!arrSplit) return false;
    const dtmBirth = new Date(`${arrSplit[2]}/${arrSplit[3]}/${arrSplit[4]}`);
    dtmBirth.setDate(Number(arrSplit[4]));
    const bGoodDay =
      dtmBirth.getFullYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) return false;

    const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let nTemp = 0;
    for (let i = 0; i < 17; i++) {
      nTemp += parseInt(num.substr(i, 1), 10) * arrInt[i];
    }
    if (arrCh[nTemp % 11] !== num.substr(17, 1).toUpperCase()) return false;
  }

  return { birthday, sex };
}
